/**
 * @description image width 50%
 * @author wangfupeng
 */

import ImageWidthBaseClass from './WidthBase'

class ImageWidth50 extends ImageWidthBaseClass {
  readonly title = '50%' // 菜单标题
  readonly value = '50%' // css width 的值
}

export default ImageWidth50
